import { CSSProperties } from "react";

export const getActiveJobLinkSearch = (): CSSProperties => {
  return { padding: "4px" };
};

export const getActiveJobLinkSearchButton = (): CSSProperties => {
  return { padding: "6px 16px" };
};
